import Helpers from '@/core/utils/helpers'

let banksOptions = [
  {
    "key": "banks-business",
    "name": "Empresas bancarias",
    "banks": [
      {
        "id": 1,
        "name": "Banco de Crédito del Perú",
        "isEnabled": false,
        "logo": "bcp.svg"
      },
      {
        "id": 2,
        "name": "Interbank",
        "legacyNames": ["Banco Internacional del Perú"],
        "isEnabled": false,
        "logo": "interbank.svg"
      },
      {
        "id": 3,
        "name": "BBVA",
        "isEnabled": false,
        "logo": "BBVA.svg"
      },
      {
        "id": 4,
        "name": "Scotiabank Perú",
        "isEnabled": false,
        "logo": "scotiabank.svg"
      },
      {
        "id": 5,
        "name": "Banco Falabella",
        "isEnabled": false,
        "logo": "Banco-Falabella.svg"
      },
      {
        "id": 6,
        "name": "Banco Ripley",
        "isEnabled": false,
        "logo": "Banco-Ripley.svg"
      },
      {
        "id": 7,
        "name": "Banco Interamericano de Finanzas",
        "isEnabled": false,
        "logo": "banbif.svg"
      },
      {
        "id": 8,
        "name": "Banco Pichincha",
        "isEnabled": false,
        "logo": "banco-pichincha.svg"
      },
      {
        "id": 9,
        "name": "Banco de Comercio",
        "isEnabled": false,
        "logo": "bancom.svg"
      },
      {
        "id": 10,
        "name": "Citibank Perú",
        "isEnabled": false,
        "logo": "citibank.svg"
      },
      {
        "id": 11,
        "name": "MiBanco",
        "isEnabled": false,
        "logo": "MiBanco.svg"
      },
      {
        "id": 12,
        "name": "Banco GNB Perú",
        "isEnabled": false,
        "logo": "Banco-GNB.svg"
      },
      {
        "id": 13,
        "name": "Banco Santander Perú",
        "isEnabled": false,
        "logo": "Banco-Santander-Peru.svg"
      },
      {
        "id": 14,
        "name": "Alfin Banco",
        "isEnabled": false,
        "logo": "Alfin-Banco.svg"
      },
      {
        "id": 15,
        "name": "Bank of China",
        "isEnabled": false,
        "logo": "Bank-of-China.svg"
      },
      {
        "id": 16,
        "name": "Banco Bci",
        "legacyNames": ["Bci Perú"],
        "isEnabled": false,
        "logo": "Bci-Peru.svg"
      },
      {
        "id": 17,
        "name": "ICBC PERU BANK",
        "isEnabled": false,
        "logo": "ICBC-PERU-BANK.svg"
      }
    ]
  },
  {
    "key": "financial-companies",
    "name": "Empresas financieras",
    "banks": [
      {
        "id": 18,
        "name": "Crediscotia",
        "isEnabled": false,
        "logo": "Crediscotia.svg"
      },
      {
        "id": 19,
        "name": "Confianza",
        "isEnabled": false,
        "logo": "Confianza.svg"
      },
      {
        "id": 20,
        "name": "Compartamos",
        "isEnabled": false,
        "logo": "Compartamos.svg"
      },
      {
        "id": 21,
        "name": "Credinka",
        "isEnabled": false,
        "logo": "Credinka.svg"
      },
      {
        "id": 22,
        "name": "Efectiva",
        "isEnabled": false,
        "logo": "Efectiva.svg"
      },
      {
        "id": 23,
        "name": "Proempresa",
        "isEnabled": false,
        "logo": "Proempresa.svg"
      },
      {
        "id": 24,
        "name": "Mitsui Auto Finance",
        "isEnabled": false,
        "logo": "Mitsui-Auto-Finance.svg"
      },
      {
        "id": 25,
        "name": "Financiera Oh!",
        "isEnabled": false,
        "logo": "Oh.svg"
      },
      {
        "id": 26,
        "name": "Qapaq",
        "isEnabled": false,
        "logo": "Qapaq.svg"
      }
    ]
  },
  {
    "key": "state-financial-entities",
    "name": "Entidades Financieras Estatales",
    "banks": [
      {
        "id": 27,
        "name": "Agrobanco",
        "isEnabled": false,
        "logo": "agrobanco.svg"
      },
      {
        "id": 28,
        "name": "Banco de la Nación",
        "isEnabled": false,
        "logo": "bdelanacion.svg"
      },
      {
        "id": 29,
        "name": "COFIDE",
        "isEnabled": false,
        "logo": "cofide.svg"
      },
      {
        "id": 30,
        "name": "Fondo MiVivienda",
        "isEnabled": false,
        "logo": "mivivienda.svg"
      }
    ]
  },
  {
    "key": "cmac",
    "name": "Cajas Municipales de Ahorro y Crédito (CMAC)",
    "banks": [
      {
        "id": 31,
        "name": "Arequipa",
        "isEnabled": false,
        "logo": "caja-arequipa.svg"
      },
      {
        "id": 32,
        "name": "Cusco",
        "isEnabled": false,
        "logo": "caja-cuzco.svg"
      },
      {
        "id": 33,
        "name": "Del Santa",
        "isEnabled": false,
        "logo": "caja-del-santa.svg"
      },
      {
        "id": 34,
        "name": "Trujillo",
        "isEnabled": false,
        "logo": "caja-trujillo.svg"
      },
      {
        "id": 35,
        "name": "Huancayo",
        "isEnabled": false,
        "logo": "caja-huancayo.svg"
      },
      {
        "id": 36,
        "name": "Ica",
        "isEnabled": false,
        "logo": "caja-ica.svg"
      },
      {
        "id": 37,
        "name": "Maynas",
        "isEnabled": false,
        "logo": "caja-maynas.svg"
      },
      {
        "id": 38,
        "name": "Paita",
        "isEnabled": false,
        "logo": "caja-paita.svg"
      },
      {
        "id": 39,
        "name": "Piura",
        "isEnabled": false,
        "logo": "caja-piura.svg"
      },
      {
        "id": 40,
        "name": "Sullana",
        "isEnabled": false,
        "logo": "caja-sullana.svg"
      },
      {
        "id": 41,
        "name": "Tacna",
        "isEnabled": false,
        "logo": "caja-tacna.svg"
      }
    ]
  },
  {
    "key": "cmcp",
    "name": "Cajas Municipales de Crédito y Popular (CMCP)",
    "banks": [
      {
        "id": 42,
        "name": "Caja Metropolitana de Lima",
        "isEnabled": false,
        "logo": "caja-municipal.svg"
      }
    ]
  }
]

let list = []

banksOptions.forEach(item => {
  item.banks.forEach(bank => bank.slug = Helpers.sluglify(bank.name))
  list.push(...item.banks)
})

// Los ids son fijos: se guardan como bankId en los datos de WIRE_TRANSFER.
// No cambiar ni reutilizar un id existente; un banco nuevo usa el siguiente id libre.
const ids = list.map(bank => bank.id)
if (ids.some(id => !Number.isInteger(id)) || new Set(ids).size !== ids.length) {
  console.error("banks.js: hay bancos sin id o con ids repetidos")
}

// Pone el nombre actual del banco en cada cuenta guardada (bankId). Solo si el nombre
// guardado es el actual o uno anterior del mismo banco (legacyNames): las cuentas
// guardadas con los ids de la lista antigua (antes de junio 2024) se dejan como están.
export function withCurrentBankNames(accounts) {
  return accounts.map(account => {
    const bank = list.find(item => item.id == account.bankId)
    if (bank && account.bank !== bank.name && (bank.legacyNames || []).includes(account.bank)) {
      return { ...account, bank: bank.name }
    }
    return account
  })
}

export default banksOptions
